import { useState, useEffect } from "react";

import { makeStyles } from "@mui/styles";
import CircularProgress from "@mui/material/CircularProgress";

import Box from "@mui/material/Box";
import Switch from "@mui/material/Switch";

import {
  Card,
  CardActions,
  CardContent,
  Divider,
  Button,
  Grid,
  TextField,
  Typography,
} from "@mui/material";

import clsx from "clsx";

import { useDispatch } from "react-redux";

import API from "util/API";
import { useHistory } from "react-router-dom";
import { useForm, Controller } from "react-hook-form";
import {
  showSuccessSnackbar,
  showErrorSnackbar,
} from "store/actions/snackbarMessage";
import { noWheelInputProps } from "util/utils";

const useStyles = makeStyles((theme) => ({
  content: {
    flexGrow: 1,
    padding: theme.spacing(3),
    marginTop: theme.spacing(2),
  },
  toolbar: theme.mixins.toolbar,
  root: {
    padding: theme.spacing(3),
  },
  details: {
    display: "flex",
  },
  avatar: {
    height: 110,
    width: 100,
    flexShrink: 0,
    flexGrow: 0,
  },
  locationText: {
    paddingLeft: "15px",
  },
  buttonProperty: {
    position: "absolute",
    top: "50%",
  },
  uiProgess: {
    position: "fixed",
    zIndex: "1000",
    height: "31px",
    width: "31px",
    left: "50%",
    top: "35%",
  },
  progess: {
    position: "absolute",
  },
  uploadButton: {
    marginLeft: "8px",
    margin: theme.spacing(1),
  },
  customError: {
    color: "red",
    fontSize: "0.8rem",
    marginTop: 10,
  },
  submitButton: {
    marginTop: "10px",
  },
  Media: {},
}));

const BirthdayPromotion = (props) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const promotionId = props.match.params.promotionId;

  const {
    setValue,
    handleSubmit,
    control,
    formState: { errors },
  } = useForm();

  const onSubmit = (data) => {
    saveOrUpdatePromotion(data);
  };

  const history = useHistory();

  const [uiLoading, setUiLoading] = useState(false);
  const [isPercentageType, setIsPercentageType] = useState(true);
  const [promotion, setPromotion] = useState(null);
  const [buttonLoading, setButtonLoading] = useState(false);
  

  const showError = (msg) => dispatch(showErrorSnackbar(msg));
  const showSuccess = (msg) => dispatch(showSuccessSnackbar(msg));

  

  useEffect(() => {
    getPromotion(promotionId);
  }, [promotionId]);

  const toggleIsPercentage = () => {
    setIsPercentageType(!isPercentageType);
  };

  const getPromotion = async (promoId) => {
    if (!promoId || promoId.length === 0) {
      return;
    }
    setUiLoading(true);
    try {
      const response = await API.get(`/promotions/${promoId}`);
      if (response && response.data && response.data.promotion) {
        setPromotion(response.data.promotion);
      }
      setUiLoading(false);
    } catch (err) {
      setUiLoading(false);
      showError("Something went wrong, please try again.");
    }
  };

  useEffect(() => {
    if (promotion) {
      setTimeout(() => {
        setValue("isEnabled", promotion.isEnabled);
        setValue("name", promotion.name);
        setValue("description", promotion.description);
        setValue("maxAmount", promotion.maxAmount);
        setValue("isPercentage", promotion.isPercentage);
        setValue("percentage", promotion.percentage);
        setValue("amount", promotion.amount);
        setValue("expiryDays", promotion.expiryDays);
      });
    }
  }, [promotion, setValue]);

  const saveOrUpdatePromotion = async (data) => {
    setButtonLoading(true);

    const formRequest = {
      promotion: { ...data, type: "birthday" },
      promotionId,
    };
    
      try {
        await API.post("/promotions", formRequest);
        setButtonLoading(false);
        showSuccess("Saved successfully");
        history.push("/promotions");
      } catch (error) {
        if (error.response && error.response.status === 403) {
          props.history.push("/sign-in");
        }
        console.log(JSON.stringify(error));
        setButtonLoading(false);
        showError("Something went wrong, please try again.");
      }
    
  };

  if (uiLoading === true) {
    return (
      <main className={classes.content}>
        {uiLoading && (
          <CircularProgress size={150} className={classes.uiProgess} />
        )}
      </main>
    );
  } else {
    return (
      <div className={classes.root}>
        <div className={classes.content}>
            <form onSubmit={handleSubmit(onSubmit)}>
              <Card className={clsx(classes.root, classes)}>
                <Box m={1}>
                  <Typography variant="h3">
                    {" "}
                    Birthday Promotion
                  </Typography>
                </Box>
                <Divider />
                <CardContent>
                  <Grid container spacing={3}>
                    <Grid item md={6} xs={12}>
                      <Typography>Enabled</Typography>
                      <Controller
                        name="isEnabled"
                        defaultValue={true}
                        control={control}
                        render={({ field: { onChange, value } }) => (
                          <Switch
                            onChange={(e) => onChange(e.target.checked)}
                            checked={value || false}
                          />
                        )}
                      />
                    </Grid>

                    <Grid item md={6} xs={12}>
                      <Typography>Is for one item</Typography>
                      <Controller
                        name="forOneItem"
                        defaultValue={true}
                        control={control}
                        render={({ field: { onChange, value } }) => (
                          <Switch
                            onChange={(e) => onChange(e.target.checked)}
                            checked={value || false}
                          />
                        )}
                      />
                    </Grid>

                    <Grid item md={6} xs={12}>
                      <Typography>Name</Typography>
                      <Controller
                        name="name"
                        control={control}
                        rules={{ required: true, maxLength: 20 }}
                        render={({ field }) => (
                          <TextField {...field} type="text" value={field.value || ""} />
                        )}
                      />
                      {errors.name && (
                        <Typography>
                          <Box color="error.main">Name is required</Box>
                        </Typography>
                      )}
                    </Grid>

                    <Grid item md={6} xs={12}>
                      <Typography>Description</Typography>
                      <Controller
                        name="description"
                        control={control}
                        rules={{ required: true, maxLength: 50 }}
                        render={({ field }) => (
                          <TextField {...field} type="text" multiline value={field.value || ""} />
                        )}
                      />
                      {errors.description && (
                        <Typography>
                          <Box color="error.main">Description is required</Box>
                        </Typography>
                      )}
                    </Grid>

                    <Grid item md={6} xs={12}>
                      <Typography>Is percentage discount</Typography>
                      <Controller
                        name="isPercentage"
                        defaultValue={true}
                        control={control}
                        render={({ field: { onChange, value } }) => (
                          <Switch
                            onChange={(e) => { onChange(e.target.checked); toggleIsPercentage(); }}
                            checked={value || false}
                          />
                        )}
                      />
                    </Grid>

{isPercentageType ?
                    <Grid item md={6} xs={12}>
                      <Typography>Discount Percentage (%)</Typography>
                      <Controller
                        name="percentage"
                        control={control}
                        rules={{
                          required: true,
                        }}
                        render={({ field }) => (
                          <TextField {...field} type="number" inputProps={noWheelInputProps} value={field.value || ""} />
                        )}
                      />
                      {errors.maxAmount && (
                        <Typography>
                          <Box color="error.main">
                            The discount percentage is required.
                          </Box>
                        </Typography>
                      )}
                    </Grid> :

                    <Grid item md={6} xs={12}>
                      <Typography>Discount amount</Typography>
                      <Controller
                        name="amount"
                        control={control}
                        rules={{
                          required: true,
                        }}
                        render={({ field }) => (
                          <TextField {...field} type="number" inputProps={noWheelInputProps} value={field.value || ""} />
                        )}
                      />
                      {errors.maxAmount && (
                        <Typography>
                          <Box color="error.main">
                            The discount amount is required.
                          </Box>
                        </Typography>
                      )}
                    </Grid>}

                    <Grid item md={6} xs={12}>
                      <Typography>Maximum Amount</Typography>
                      <Controller
                        name="maxAmount"
                        control={control}
                        rules={{
                          required: true,
                        }}
                        render={({ field }) => (
                          <TextField {...field} type="number" inputProps={noWheelInputProps} value={field.value || ""} />
                        )}
                      />
                      {errors.maxAmount && (
                        <Typography>
                          <Box color="error.main">
                            The maximum amount is required.
                          </Box>
                        </Typography>
                      )}
                    </Grid>

                    <Grid item md={6} xs={12}>
                      <Typography>Voucher Expriry days</Typography>
                      <Controller
                        name="expiryDays"
                        control={control}
                        rules={{
                          required: true,
                          min: 1,
                        }}
                        render={({ field }) => (
                          <TextField {...field} type="number" inputProps={noWheelInputProps} value={field.value || ""} />
                        )}
                      />
                      {errors.expiryDays && (
                        <Typography>
                          <Box color="error.main">Expriry days is required</Box>
                        </Typography>
                      )}
                    </Grid>
                  </Grid>
                </CardContent>

                <CardActions />
              </Card>

              <Button
                color="primary"
                variant="contained"
                type="submit"
                className={classes.submitButton}
                disabled={buttonLoading}
              >
                Save
                {buttonLoading && (
                  <CircularProgress size={30} className={classes.progess} />
                )}
              </Button>
            </form>
          </div>
      </div>
    );
  }
};

export default BirthdayPromotion;
